(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caldrenova-home-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('caldrenova-home-film')) {
    customElements.define('caldrenova-home-film', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = true;
        this.userPaused = false;
        this.motionOverride = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.addEventListener('playing', () => {
          this.classList.add('is-playing', 'is-running');
          this.button.setAttribute('aria-label', 'Pause video');
        }, options);
        this.video.addEventListener('pause', () => {
          this.classList.remove('is-running');
          this.button.setAttribute('aria-label', 'Play video');
        }, options);
        this.video.addEventListener('error', () => {
          this.classList.remove('is-playing', 'is-running');
          this.button.setAttribute('aria-label', 'Play video');
        }, options);
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.motionOverride = true;
            this.resume();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('click', () => this.button.click(), options);
        this.mobile.addEventListener('change', () => this.selectSource(), options);
        this.reduced.addEventListener('change', () => {
          this.motionOverride = false;
          if (this.reduced.matches) this.video.pause(); else this.resume();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause(); else this.resume();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.resume(); else this.video.pause();
        }, { threshold: 0.05 });
        this.observer.observe(this.video);
        this.selectSource();
      }
      selectSource() {
        const src = this.mobile.matches ? this.dataset.mobileVideo : this.dataset.desktopVideo;
        if (!src || this.activeSource === src) return;
        this.activeSource = src;
        this.video.pause();
        this.classList.remove('is-playing', 'is-running');
        this.video.poster = this.mobile.matches ? this.dataset.mobilePoster : this.dataset.desktopPoster;
        this.video.src = src;
        this.video.load();
        this.button.hidden = false;
        this.resume();
      }
      resume() {
        if (!this.activeSource || document.hidden || !this.inView || this.userPaused || (this.reduced.matches && !this.motionOverride)) return;
        const result = this.video.play();
        if (result) result.catch(() => {
          if (this.video.paused) this.button.setAttribute('aria-label', 'Play video');
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.activeSource = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caldrenova-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-store-reviews')) {
    customElements.define('cn-store-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const photoDialog = this.querySelector('[data-photo-dialog]');
        let photoButtons = [], photoIndex = 0, photoTrigger;
        const renderPhoto = () => {
          const image = photoDialog.querySelector('[data-large-photo]');
          image.src = photoButtons[photoIndex].dataset.photoUrl;
          image.alt = photoButtons[photoIndex].querySelector('img')?.alt || '';
          photoDialog.querySelector('[data-photo-counter]').textContent = (photoIndex + 1) + ' / ' + photoButtons.length;
        };
        const photoClick = event => {
          const button = event.target.closest('[data-review-photo]');
          if (!button || !photoDialog) return;
          photoButtons = [...button.closest('article').querySelectorAll('[data-review-photo]')];
          photoIndex = photoButtons.indexOf(button); photoTrigger = button; renderPhoto(); photoDialog.showModal();
        };
        const changePhoto = delta => {photoIndex = (photoIndex + delta + photoButtons.length) % photoButtons.length; renderPhoto();};
        this.addEventListener('click', photoClick);
        photoDialog?.querySelector('[data-close-photo]').addEventListener('click', () => photoDialog.close());
        photoDialog?.querySelector('[data-prev-photo]').addEventListener('click', () => changePhoto(-1));
        photoDialog?.querySelector('[data-next-photo]').addEventListener('click', () => changePhoto(1));
        photoDialog?.addEventListener('close', () => photoTrigger?.focus());
        const nativeCount = Number(this.dataset.nativeCount) || 0;
        let adapterCount = 0;
        const app = this.querySelector('[data-reviews-app]');
        const sync = () => {
          const counts = app ? [...app.querySelectorAll('[data-caldrenova-review-count]')].map(x => Number(x.dataset.caldrenovaReviewCount) || 0) : [];
          this.hidden = !(nativeCount > 0 || adapterCount > 0 || counts.some(count => count > 0));
        };
        const update = event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          const count = Number(event.detail?.publishedCount);
          adapterCount = Number.isFinite(count) ? Math.max(0, count) : 0;
          sync();
        };
        const dialog = this.querySelector('dialog');
        const openButton = this.querySelector('[data-open-reviews]');
        const closeButton = this.querySelector('[data-close-reviews]');
        const show = () => {
          if (!dialog || !dialog.showModal) return;
          const target = dialog.querySelector('[data-all-reviews]');
          target.replaceChildren();
          this.querySelectorAll('[data-review-list] [data-native-review]').forEach(card => {
            const clone = card.cloneNode(true);
            clone.removeAttribute('data-shopify-editor-block');
            target.append(clone);
          });
          dialog.showModal();
        };
        const close = () => dialog?.close();
        const restoreFocus = () => openButton?.focus();
        openButton?.addEventListener('click', show);
        closeButton?.addEventListener('click', close);
        dialog?.addEventListener('close', restoreFocus);
        document.addEventListener('caldrenova:reviews-updated', update);
        const observer = app ? new MutationObserver(sync) : null;
        if (app) observer.observe(app, {childList:true, subtree:true, attributes:true, attributeFilter:['data-caldrenova-review-count']});
        sync();
        this.cleanup = () => {
          this.removeEventListener('click', photoClick);
          if (photoDialog?.open) photoDialog.close();
          observer?.disconnect();
          openButton?.removeEventListener('click', show);
          closeButton?.removeEventListener('click', close);
          dialog?.removeEventListener('close', restoreFocus);
          document.removeEventListener('caldrenova:reviews-updated', update);
          if (dialog?.open) dialog.close();
        };
      }
      disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caldrenova-home-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-home-film')) {
    customElements.define('cn-home-film', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        if (!video || !button) return;
        const sync = () => {
          const playing = !video.paused && !video.ended;
          this.classList.toggle('is-playing', playing);
          button.hidden = playing;
        };
        const start = async () => {
          status.textContent = '';
          try { await video.play(); }
          catch { status.textContent = 'Unable to play. Please try again.'; sync(); }
        };
        const solo = () => {
          this.closest('.cn-home-story__films')?.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          sync();
        };
        const fail = () => { status.textContent = 'Unable to load this film. Please try again.'; sync(); };
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: 0.1 }) : null;
        observer?.observe(this);
        button.addEventListener('click', start);
        video.addEventListener('play', solo);
        video.addEventListener('pause', sync);
        video.addEventListener('ended', sync);
        video.addEventListener('error', fail);
        sync();
        this.cleanup = () => {
          observer?.disconnect(); video.pause();
          button.removeEventListener('click', start);
          video.removeEventListener('play', solo);
          video.removeEventListener('pause', sync);
          video.removeEventListener('ended', sync);
          video.removeEventListener('error', fail);
        };
      }
      disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
